import { Component, Injectable, Input, OnInit, ElementRef, HostListener, OnDestroy, ViewChild, Optional, Output, EventEmitter, ChangeDetectorRef, Renderer2 } from '@angular/core';

// Data model
import { ProductModel, ICart , IConfigObj, IStpprDataObj, QuickAddBasketV1Service, QtyStepperOptions, CustomizationData } from 'abs-ngx-library/src/lib/core';
import { CommonService, UserInfoService , CartService , CartV2Service, ProductUtilService , ProductCouponService, UtilService } from 'abs-ngx-library/src/lib/core';

import { EnviormentConfig, AemService } from 'abs-ngx-library/src/lib/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription, first, map, Observable } from 'rxjs';
import { ToasterALV1Service, ToasterMessageHelper, ToasterMessages, ToasterType } from 'abs-ngx-library/src/lib/toaster-al';
import { QuickAddCheckboxService } from 'abs-ngx-library/src/lib/core'
import { CtaType } from '../../enums/cta-type.enum';

// jQuery
declare let $: any;

interface IncrementPriceList {
    price: string;
    weight: string;
}

@Component({
    selector: 'quantity-stepper-al-v2',
    templateUrl: './quantity-stepper-al-v2.component.html',
    styleUrls: ['./quantity-stepper-al-v2.component.scss']
})

@Injectable()
export class QuantityStepperALV2Component implements OnInit, OnDestroy {
    private static _xerCache = new Map<string, any>();

    @Input() product: ProductModel;
    @Input() calledBy: string;
    @Input() stpprDataObj: IStpprDataObj;
    @Input() configObj: IConfigObj;
    @Output() qtyStepperExpandEmitter = new EventEmitter<Object>();
    @Output() qtyStepperInfoEmitter = new EventEmitter<Object>();
    @Input() qtyStepperOptions: QtyStepperOptions;
    @Input() hideCTA: boolean = false;

    @ViewChild('decreaseBtn')  decreaseBtn: ElementRef;
    @ViewChild('spinnerBlock') spinnerBlock: ElementRef;
    @ViewChild('addBtn') addBtn: ElementRef;
    @ViewChild('qtyInfoBtn') qtyInfoBtn: ElementRef;
    @ViewChild('qscStepperBubble') qscStepperBubble: ElementRef;
    @ViewChild('qscIncreaseBtn') qscIncreaseBtn: ElementRef;
    // DFTA - wcax env config
    private config = EnviormentConfig;
    public ctaLabel: string;
    public REMOVE = 'Remove';
    // Disables the Add/Customize/Preorder CTA when editing a future order whose reserved slot
    // is still outside the T-13 day edit window (new items can't be added yet).
    public isFutureOrderAddDisabled: boolean = false;
    // Root-level isFutureOrder from the pending-order/edit cart response (captured on cart update).
    private currentOrderIsFutureOrder: boolean = false;

    private addItemToCartAnalytics: boolean;
    private increaseQuantityAnalytics: boolean;
    private decreaseQuantityAnalytics: boolean;
    private removeItemFromCartAnalytics: boolean;
    private analyticsPreviousPrice;
    private analyticsIsPriceDecreased: boolean;
    private isPrebookRedirect: boolean;
    public isAuthorized: boolean = false;
    public currentEnv = '';
    public baseDomainUrl = '';
    public stepperAnnouncement: string;
    private enableAdRelevanceTracking: boolean;
    private previousQuantity: number;
    public quantityAriaLabelMessage = '';
    public displayBubble: boolean = true;
    private debounceAddCart: any;
    private debounceQtyStepperExpand: any
    private debounceQtyStepperInfo: any;
    private debouncedShowOrderAmendsToaster: any;
    public loadingSpinner: boolean = false;
    private refocusButton: any = null;
    private timeouts: any[] = [];
    public reservedTimeIntent: string = '';
    public isCarouselRedesign: boolean = false;
    public isQuantityIncreased: boolean = false;
    public isGuestAddToCartABSubscription: Subscription;
    public subscriptions: Subscription = new Subscription();
    public quickAddCheckboxState$: Observable<boolean>;
    public isCheckboxChecked: boolean = false;
    public isLBProduct:boolean = false;
    public showWeights = false;
    public weightList: IncrementPriceList[] = [];
    public estimatedPrice: number = 0;
    public selectedWeight: number = 0;
    public updateState: any = {
        show: false,
        input: null
    };
    public isGuestAddToCart: boolean;

    private refreshCount =0;
    public parentCarousel: any;
    public buyItAgainCarousel : any;
    public customizationData:CustomizationData = {
        bpn: '',
        name: '',
        items: []
    };
    public showCartSlotModal: boolean = false;
    public cartSlotModalData;
    public cartModalConfig ={
        preorder_slot: {
            type: 'preorder_slot',
            modalId: 'preorder-slot-modal',
            modalOptions:{show: true},
            closeBtnSelector:'.pds-close' ,
            modalFlag: 'preorder-slot'
        },
        preorder: {
            type: 'preorder',
            modalId: 'preorder-modal',
            modalOptions:{show: true},
            closeBtnSelector:'.pds-close' ,
            modalFlag: 'preorder',
        },
        mto:{
            type: 'mto',
            modalId: 'mto-modal',
            modalOptions:{show: true},
            closeBtnSelector:'.close' ,
            analyticsTag:'mto-pickup|view',
            modalFlag: 'mto',
        },
        product_customization_modal:{
            type:'product_customization_modal',
            modalId:'isShowPreviousCustomization',
            modalOptions: {show: true},
            closeBtnSelector:'.close' ,
            modalFlag: 'product_customization_modal',
        },
        previous_customizations_error:{
           type:'previous_customizations_error',
           modalId:'productCustErrorModal',
           modalOptions: {show: true},
           closeBtnSelector:'.close' ,
           modalFlag: 'previous_customizations_error',
           isLoading: this.loadingSpinner
        },
        prebook_modal:{
            type:'prebook_modal',
            modalId:'dd-prebook-modal',
            modalOptions: {show: true},
            closeBtnSelector:'.close' ,
            isAvaialableTime:false,
            isMoreTimePrepare:false,
            preBookShortTime: '',
            preBookLongTime: '',
            modalFlag: 'prebook_modal',
        },
        prebook_slot_drawer: {
            type: 'prebook_slot_drawer',
            modalId: 'prebookSlotDrawer',
            modalOptions: { show: true },
            closeBtnSelector: '.close',
            isAvaialableTime: false,
            isMoreTimePrepare: false,
            preBookShortTime: '',
            preBookLongTime: '',
            modalFlag: 'prebook_slot_drawer',
            analyticsTag:'deli:only-available-in-time|view'
        }
    }
    public isPreviousCustomizationError:boolean = false;
    public isShowPreviousCustomization = false;
    public CtaType = CtaType;
    public dataQaAttribute: string = '';
    public dataQtyIdAttribute: string = '';
    public idAttribute: string = '';
    public disabledAttribute: boolean = false;
    public ariaLabelAttribute: string = '';
    public isDefaultCTA: boolean = false;
    private entryId: number;
    // Order Amends OTA timer properties
    public orderAmendsOTA: boolean = false;
    private globalClickUnlistener: (() => void) | null = null;
    private orderAmendsOTAQtyOnRequestFailure: number;
    public isEcomEnabled: boolean | null;
    public isCateringEnabled: boolean;
    public isPreOrderModalEnabled: boolean = false;

    public constructor(
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _elementRef: ElementRef,
        private cartService: CartService,
        private cartV2Service: CartV2Service,
        private _productUtilService: ProductUtilService,
        private _aemService: AemService,
        private _productCouponService: ProductCouponService,
        private _utilService : UtilService,
        private _http: HttpClient,
        public toasterService: ToasterALV1Service,
        private _quickAddBasketService: QuickAddBasketV1Service,
        private cdr: ChangeDetectorRef,
        private renderer: Renderer2,
        @Optional() private _quickAddCheckboxService: QuickAddCheckboxService
    ) {
        this.isAuthorized = this._userInfoService.isAuthorized();
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.baseDomainUrl = this.config[this.currentEnv]?.baseURL?.replace("{banner}", this._userInfoService.getBanner());
        this.enableAdRelevanceTracking =  !this._aemService.getFeatureFlagByNameDisable('disableAdRelevance');
        this.reservedTimeIntent = this._userInfoService.getUserChannel();
        this.debounceAddCart = this._commonService.debounce(this.addCart, 600).bind(this);
        this.debounceQtyStepperExpand = this._commonService.debounce((qty) => {this.qtyStepperExpandEmitter.emit(qty)}, 600).bind(this);
        this.debounceQtyStepperInfo = this._commonService.debounce(() => {this.qtyStepperInfoEmitter.emit()}, 600).bind(this);
        this.debouncedShowOrderAmendsToaster = this._commonService.debounce((action,selectedWeightedIndex) =>this.showOrderAmendsToaster(action, selectedWeightedIndex), 500);
    }
    @HostListener('focusout', ['$event'])
    /**
     * Handles the focus out event for the quantity stepper component.
     */
    onFocusOutEvent() {
        this.timeouts.push(setTimeout(()=> {
            this.handleDisplay();
        }, 100));
    };



    /**
     ** Initializes the component.
     */
    public ngOnInit(): void {
        this.isCateringEnabled = !this._aemService.getFeatureFlagByNameDisable('isCateringDisabled');
        this.isLBProduct = this.product?.displayType === '3' && (this.product?.sellByWeight === 'W' || this.product?.sellByWeight === 'P');
        this.isCarouselRedesign = this.calledBy === 'carousel-v2';
        this.orderAmendsOTA = this.configObj?.appName === '1P_OA';
        this.isEcomEnabled = this._commonService.getIsEcomEnabled(this.product);
        this.isGuestAddToCartABSubscription = this._commonService.isABFlagDisabledEvent$.pipe(first(event => event.flagName === 'isGuestAddToCartDisabled')).subscribe((event) => {
            this.isGuestAddToCart = (event.testValue !== 'a') && !this._userInfoService.isAuthorized() &&
                (!this.configObj.programType || this.configObj.programType === 'abs');
            this.updateCTALabel();
            if (this.calledBy === 'buyItAgainQsc') {
                this.doQuickStartCartInit();
            }
            this.getCurrentCartObj();
        });
        this._commonService.listenToABXTestingFlag('abACIP295974', 'isGuestAddToCartDisabled', 'ACIP295974',300);
        this.checkAndUpdatePrebookSlotDrawerView();
        this.computeFutureOrderAddDisabled();
    }

    /**
     * Editing a future order is only supported inside the T-13 day window. When a user is editing
     * such an order and the reserved slot is still 13+ calendar days out, new items cannot be added,
     * so the Add/Customize/Preorder CTA is disabled. This CTA renders only when the item is not yet
     * in the order (quantity === 0, which also covers customizable items), so no extra
     * "not in order" check is needed here.
     */
    private computeFutureOrderAddDisabled(): void {
        this.isFutureOrderAddDisabled = false;

        // 1. Feature must be active (the "Disabled" flag must be false)
        if (this._aemService.getFeatureFlagByNameDisable('isFutureorderDisabled')) return;

        // 2. Must be in the edit order flow
        if (!this._commonService.checkPendingOrder()) return;

        // 3. Order services response must be a future order. Read from the cart/order object the
        // component already subscribes to — fetchCartDetailsFromResponse returns the full order
        // response (root-level isFutureOrder intact) in the pending-order edit flow.
        if (!this.currentOrderIsFutureOrder) return;

        // 4. Reserved slot (abSlotEditOrder.timeSlot, ms) must be >= 13 calendar days out
        let editSlot: any = null;
        try {
            editSlot = JSON.parse(localStorage.getItem('abSlotEditOrder'));
        } catch (e) {
            editSlot = null;
        }
        const timeSlot = Number(editSlot?.timeSlot);
        if (!timeSlot) return;

        const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
        const dayDiff = Math.round((startOfDay(new Date(timeSlot)) - startOfDay(new Date())) / (24 * 60 * 60 * 1000));
        if (dayDiff < 13) return;

        this.isFutureOrderAddDisabled = true;
    }

    public updateCTALabel(): void {
        const isDigitalDeliEnabled = !this._aemService.getFeatureFlagByNameDisable('isDigitalDeliDisabled');
        const isCustomCakesEnabled = !this._aemService.getFeatureFlagByNameDisable('isCustomCakesDisabled');
        const { isMtoProduct = false, isCustomizable = false, multiCustomizations = false } = this.product || {};
        if (!this.isAuthorized && !this.isGuestAddToCart) {
            this.ctaLabel = CtaType.SIGNIN;
            this.setBtnAttributes('addButton_' + this.product.id, `${CtaType.SIGNIN} ${this.isLBProduct ? ' weight of ' : ' 1 unit of '} ${this.getProductFullName()}`, 'addbutton', `pc${this.product.id}Inpt`);
        } else {
            if (this.isPreorderElligible()) {
                this.ctaLabel = CtaType.PREORDER;
                this.setBtnAttributes('preOrderButton_' + this.product.id, `${CtaType.PREORDER} ${this.getProductFullName()}`, 'preorderButton', `pc${this.product.id}Inpt`);
                return;
            } 
            if(this.orderAmendsOTA){
                if (this.isLBProduct) {
                    this.ctaLabel = CtaType.SELECTWEIGHT;
                } else {
                    this.ctaLabel = CtaType.ADDTOORDER;
                    this.setBtnAttributes('addToOrderButton_' + this.product.id, `${CtaType.ADDTOORDER} 1 unit of ${this.getProductFullName()}`, 'addToOrderButton', `pc${this.product.id}Inpt`);
                }
                return;
            }

            if (!isDigitalDeliEnabled && !isCustomCakesEnabled) {
                if (this.isLBProduct) {
                    this.ctaLabel = CtaType.SELECTWEIGHT;
                } else {
                    this.addCTALabel();
                }
                return;
            } else {
                if(isMtoProduct && (this.isEcomEnabled) && this.isGuestAddToCart) {
                    this.isDefaultCTA = true;
                    this.ctaLabel = CtaType.SIGNIN;
                    this.setBtnAttributes('addButton_' + this.product.id, `${CtaType.SIGNIN} ${this.isLBProduct ? ' weight of ' : ' 1 unit of '} ${this.getProductFullName()}`, 'addbutton', `pc${this.product.id}Inpt`);
                    return;
                }

                if ((isMtoProduct && isCustomizable) || (this.product.isCateringProduct || this.product.isCustomCake)) {
                    if (this.isEcomEnabled === false && this.isCateringEnabled) {
                        this.ctaLabel = CtaType.TEMPORARILY_UNAVAILABLE;
                        this.setBtnAttributes('tempUnavailableButton_' + this.product.id, 'Temporarily unavailable', '', '', true);
                        return;
                    } else if (this.isEcomEnabled) {
                        this.isDefaultCTA = true;
                        if (this.calledBy === 'buyItAgain' || this.buyItAgainCarousel || this.parentCarousel?.find('[data-carousel-behaviour=buy-it-again-landing-category]').length) {
                            this.addCTALabel();
                            return;
                        } else if (isCustomizable) {
                            this.ctaLabel = CtaType.CUSTOMIZE;
                            this.setBtnAttributes('customizeButton_' + this.product.id, `${CtaType.CUSTOMIZE} ${this.getProductFullName()}`, 'customizebutton', `pc${this.product.id}Inpt`);
                            return;
                        } else {
                            if (this.isLBProduct) {
                                this.ctaLabel = CtaType.SELECTWEIGHT;
                                return;
                            } else {
                                this.addCTALabel();
                                return;
                            }
                        }
                    } else {
                        if (multiCustomizations) {
                            return;
                        } else {
                            if (this.isLBProduct) {
                                this.ctaLabel = CtaType.SELECTWEIGHT;
                                return;
                            } else {
                                this.addCTALabel();
                                return;
                            }
                        }
                    }
                } else if (this.isLBProduct) {
                    this.ctaLabel = CtaType.SELECTWEIGHT;
                    return;
                } else {
                    this.addCTALabel();
                    return;
                }
            }
        }
    }

    /**
     * Sets the CTA label to "Add" and updates the button attributes.
     */
    private addCTALabel(): void {
        this.ctaLabel = CtaType.ADD;
        this.setBtnAttributes('addButton_' + this.product.id, `${CtaType.ADD} 1 unit of ${this.getProductFullName()}`, 'addbutton', `pc${this.product.id}Inpt`);
        this.cdr.detectChanges();
    }

    private setBtnAttributes(idAttribute?, ariaLabelAttribute?, dataQaAttribute?, dataQtyIdAttribute?, disabledAttribute?): void {
        this.idAttribute = idAttribute;
        this.ariaLabelAttribute = ariaLabelAttribute;
        this.dataQaAttribute = dataQaAttribute;
        this.dataQtyIdAttribute = dataQtyIdAttribute;
        this.disabledAttribute = disabledAttribute || false;
    }

    public ngAfterViewInit() {
        this.parentCarousel = $(this._elementRef.nativeElement).closest('.slick-product-carousel');
        this.buyItAgainCarousel = this.parentCarousel?.find('[data-carousel-behaviour=buy-it-again]').length || this.parentCarousel?.find('[data-carousel-behaviour=buy-it-again-landing-category]').length;
        if(this.buyItAgainCarousel && (this.isAuthorized || this.isGuestAddToCart) && this.isDigitalDeliElgible()){
            this.isDefaultCTA = true;
            this.addCTALabel()
        }
    }

    enableListener() {
    if (!this.globalClickUnlistener) {
      this.globalClickUnlistener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
        this.handleDocumentClick(event);
      });
    }
  }

   disableListener() {
    if (this.globalClickUnlistener) {
      this.globalClickUnlistener();
      this.globalClickUnlistener = null;
    }
  }

  private handleDocumentClick(event: MouseEvent) {
    const modalElem = document.querySelector('#item-search-modal .modal-content') as HTMLElement;
    if (!modalElem) return;


    const targetEl = event.target as HTMLElement;


    if (modalElem.contains(targetEl) &&
        this.toasterService.toasterRef?.ref?.instance?.data?.title === 'order-amends-ota') {
        const shouldCallAPI = this.toasterService.toasterRef?.ref?.instance?.data?.type === ToasterType.Success;
        this.toasterService.toasterRef?.close(shouldCallAPI);
    }
  }
     /**
     * Checks and initializes the prebook slot drawer view if called by for prebook-slot-drawer.
     */
    public checkAndUpdatePrebookSlotDrawerView(): void {
        if (this.calledBy === 'prebook-slot-drawer') {
            this.updatePrebookData('prebook_slot_drawer')
        }
    }

    /**
     * Updates prebook Model Data.
     */
    private updatePrebookData(moodalType:string):void{
        this.showCartSlotModal = true;
        if (this.prepTimeExceedsPrebook()) {
            this.cartSlotModalData = {
                ...this.cartModalConfig[moodalType],
                isMoreTimePrepare: true
            };
        } else {
            const { shortFormat, longFormat } = this._productUtilService.formatTimeSlots('abSlot');
            this.cartSlotModalData = {
                ...this.cartModalConfig[moodalType],
                isAvaialableTime: true,
                preBookShortTime: shortFormat,
                preBookLongTime: longFormat

            };
        }

    }

    /**
     * Lifecycle hook that is called when the component is about to be destroyed.
     * It clears all the timeouts and releases any resources held by the component.
     */
    public ngOnDestroy(): void {
        this.timeouts.forEach(timeout => {
            clearTimeout(timeout);
            this.timeouts = [];
        });
        if(this.isGuestAddToCartABSubscription){
            this.isGuestAddToCartABSubscription.unsubscribe();
        }
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        this.disableListener();
    };

    /**
     * Handles the display logic for the quantity stepper component.
     * If the component does not have focus and is not an LB product, it displays the bubble.
     * If the component does not have focus and is an LB product, it hides the weights.
     */
    private handleDisplay() {
        const focusedElement = this._elementRef.nativeElement.querySelector(':focus');
        const hasFocus = focusedElement !== null;
        if(!hasFocus) {
            if(this.isLBProduct) {
                this.toggleDisplayWeights(false);
            } else {
                this.displayBubble = true;
                this.updateState.show = false;
            }

        }
    };

    /**
     * Add current product in cart.
     *
     * @param {any} quantity New stepper's quantity.
     */
    public async addCart(quantity: number): Promise<void> {

        this.loadingSpinner = true;

        if (quantity === 0) {
            this._removeProduct();
        } else {
            if (!this.isGuestAddToCart) {
                await this._handleAutoClip();
            }
            this._cartAPICall(quantity);
        }

    }

    /**
     * Handles auto-clip logic gated by XER A/B experimentation.
     * Group A or not eligible → invoke auto clip (BAU).
     * Group B → skip auto clip.
     * Feature flag disabled or SDK unavailable → BAU fallback.
     */
    private async _handleAutoClip(): Promise<void> {
        if (!this._commonService.isFeatureEnabled('isAutoClipABTestEnabled')) {
            this._clipDigitalCoupon();
            return;
        }

        const featureId = 'ACIP585422';
        try {
            if (!QuantityStepperALV2Component._xerCache.has(featureId)) {
                const data = await this._commonService.getExperimentIdData(featureId, false);
                QuantityStepperALV2Component._xerCache.set(featureId, data ?? null);
            }

            const xerData = QuantityStepperALV2Component._xerCache.get(featureId);
            const isEligible = xerData?.eligible || false;
            const group = xerData?.group;

            if (!isEligible || group === 'A' || !group) {
                this._clipDigitalCoupon();
            }
            // Group B → skip auto clip
        } catch (error) {
            // Fallback to BAU on unexpected error
            this._clipDigitalCoupon();
        }
    }

    _clipDigitalCoupon() {
        //Calling auto clip digital coupon method
        this._productCouponService.clipDigitalCoupon(this.product.upc);
    }

    /**
     * Retrieves the current cart object and updates the quantity of the product.
     */
    private getCurrentCartObj() {
        let obs = this._commonService.currentCartObj;
        const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);

        obs = obs.pipe(map(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));

        obs.subscribe(objCart => {
            if (this.calledBy !== 'buyItAgainQsc') {
                this.handleDefaultCartUpdate(objCart);
            } else if (this.calledBy === 'buyItAgainQsc') {
                this.handleQscCartUpdate(objCart);
            }
        });
    };

    /**
     * Helper function to do the general flow for updating products on cart update.
     */
    private handleDefaultCartUpdate(objCart: any) {
        let qty: any = 0;
        let list: any = [];

        try {
            let cartProduct: any = {};
            cartProduct = objCart?.['cartItems']?.find(item => item.itemId == this.product.id);

            if (cartProduct) {
                const productQty = cartProduct.qty ?? cartProduct.quantity;
                qty = this.isLBProduct ? (cartProduct.selectedWeight ??
                    (productQty)) : (productQty);
                list = cartProduct.incrementPriceList ?? [];
                this.product.maxPurchaseQty = cartProduct?.maxPurchaseQty;
                this.entryId = cartProduct?.entryId;
            } else {
                qty = 0;
                list = [];
                this.entryId = null;
            }

            qty = (qty > 0) ? qty : 0;

        } catch (e) {
            qty = 0;
            list = [];
        }

        if (!this.isDigitalDeliElgible() && !this._commonService.isEligibleCustomCakeProduct(this.product)) {
            this.product.quantity = qty;
            this.previousQuantity = qty;
            this.weightList = list;
            this.selectedWeight = qty;
        } else {
            this.product.quantity = 0;
        }
        if (this.calledBy === 'qtyStepperExpand') {
            this.product.quantity = this.qtyStepperOptions?.quantity ?? (this.isLBProduct ? parseFloat(this.product.incrementPriceList[0].weight): 1);
        }

        const orderAmendsCurrentOrderData = this._commonService.orderAmendsCurrentOrderData;
        if(this.orderAmendsOTA && orderAmendsCurrentOrderData && !this._commonService.isEmpty(orderAmendsCurrentOrderData.orderItems)) {
            const orderItem = orderAmendsCurrentOrderData.orderItems.find(item => item.bpnNum === this.product.id);
            const quantity = this.isLBProduct ? parseFloat(orderItem?.orderedWeight ?? '0') : (orderItem?.quantity ?? 0);
            this.product.quantity = quantity;
            this.selectedWeight = quantity;
            this.previousQuantity = quantity;
            this.weightList = this.isLBProduct ? this.product.incrementPriceList?.filter((w: IncrementPriceList) => parseFloat(w.weight) >= this.selectedWeight) : this.weightList;
        }

        const inCartText = this.orderAmendsOTA ? 'added to order' : 'in cart';

        if (this.isLBProduct && !this.isDefaultCTA && this.isEcomEnabled !== false) {
            this.ctaLabel = this.selectedWeight != 0 ? `${this.selectedWeight?.toFixed(2)} lb` : `Select wt`;
            this.quantityAriaLabelMessage = `${this.selectedWeight} lb of ${this.product.name} ${inCartText}. Click to update`; 
        } else {
            const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
            this.quantityAriaLabelMessage = `${this.product.quantity} ${unitTxt} of ${this.product.name} ${inCartText}. Click to update`;
        }

        // Capture root-level isFutureOrder from the (full) pending-order response, then
        // re-evaluate once the order/cart data has resolved (it may arrive async).
        this.currentOrderIsFutureOrder = !!objCart?.isFutureOrder;
        this.computeFutureOrderAddDisabled();
    }

    // Unlike the general flow, we wont setup our data on the first cart subscriber call. We will just handle updating the LS in case the cart updates. 
    private handleQscCartUpdate(objCart: any) {
        // Capture root-level isFutureOrder and re-evaluate BEFORE the early return, so the
        // add-restriction still applies to items not yet in the quick-start cart.
        this.currentOrderIsFutureOrder = !!objCart?.isFutureOrder;
        this.computeFutureOrderAddDisabled();

        let qty = 0;
        const matchingItem = objCart?.cartItems?.find(item => item.itemId == this.product.id);
        if (!matchingItem) { return };

        qty = this.isLBProduct ? (matchingItem.selectedWeight ??
            (matchingItem.qty ?? matchingItem.quantity)) : (matchingItem.qty ?? matchingItem.quantity);

        this.isLBProduct ? this._quickAddBasketService.setQuickAddBasketItemWeight(this.product.id, qty) : this._quickAddBasketService.setQuickAddBasketItemQuantity(this.product.id, qty);
        this.product.quantity = qty;
        this.previousQuantity = qty;
        this.selectedWeight = qty;
        if (this.isLBProduct) {
            this.ctaLabel = this.selectedWeight != 0 ? `${this.selectedWeight?.toFixed(2)} lb` : `Select wt`;
            this.quantityAriaLabelMessage = this.selectedWeight + ' lb of ' + this.product.name + ' selected in your quick start cart. Click to update';
        } else {
            const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
            this.quantityAriaLabelMessage = this.product.quantity + ` ${unitTxt} of ` + this.product.name + ' selected in your quick start cart. Click to update';
        }
    }


    /**
     * Initializes state specifically for QSC flow. 
     * QSC flow differs from the general by starting in the bubble state and having the minimum quantity already selected.
     */
    private doQuickStartCartInit() {
        if (this._quickAddCheckboxService !== undefined) {
            this.quickAddCheckboxState$ = this._quickAddCheckboxService.isChecked$;
            this.subscriptions.add(this.quickAddCheckboxState$.subscribe((state) => {
                this.handleStepperStateOnCheckboxChange(state);
            }))
        }
        if (this.isLBProduct) {
            this.product.quantity = Number(this._quickAddBasketService.getQuickAddBasketItemWeight(this.product.id));
            this.weightList = this.product.incrementPriceList ?? [];
        } else {
            this.product.quantity = this._quickAddBasketService.getQuickAddBasketItemQuantity(this.product.id);
        }
        this.selectedWeight = this.product.quantity;
        this.previousQuantity = this.product.quantity;
        this.displayBubble = true;

        if (this.isLBProduct) {
            this.quantityAriaLabelMessage = this.selectedWeight + ' lb of ' + this.product.name + ' selected in your quick start cart. Click to update';
            this.ctaLabel = this.selectedWeight != 0 ? `${this.selectedWeight?.toFixed(2)} lb` : 'Select wt';
        } else {
            const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
            this.quantityAriaLabelMessage = this.product.quantity + ` ${unitTxt} of ` + this.product.name + ' selected in your quick start cart. Click to update';
        }
    }

    private handleStepperStateOnCheckboxChange(state: boolean) {
        this.isCheckboxChecked = state;
        // Set quantity stepper state to bubble if its in expanded state and checkbox is toggled off.
        if (this.displayBubble == false && state == false) {
            this.displayBubble = true;
        }
    }

    /**
     * Retrieves the full name of the product.
     * If the product has a full name, it is returned. Otherwise, the product name is returned.
     * @returns The full name of the product.
     */
    public getProductFullName() {
        let fullName = '';

        if (this.product)
            fullName = this.product.fullName && this.product.fullName.length ? this.product.fullName : this.product.name;

        return fullName;
    }

    /**
     * Update analytics product info.
     */
    private _updateAnalyticsProductInfo(sellerId?): void {
        // check for datalayer availability, in case component is loaded on pages without the AEM datalayer
        if (window['AB']?.DATALAYER) {
            // determine whether the current stepper is on a product that is part of the cross-sell component
            const isCrossSell = this.isLBProduct ? false : (this._elementRef.nativeElement.closest('cross-sell') ? true : false);
            const isBIACrossSell = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-crossSell"]')?.length;
            const isBIASpaCarousel = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-spaCarousel"]')?.length;
            let carouselTitle = '';
            if (this.stpprDataObj?.carouselTitle) {
                carouselTitle = this.stpprDataObj.carouselTitle;
            } else if (isBIACrossSell) {
                carouselTitle = this._elementRef.nativeElement.closest('cross-sell')?.querySelector('.cross-sell__header .cross-sell__title')?.textContent;
            } else if (isBIASpaCarousel) {
                carouselTitle = this._elementRef.nativeElement.closest('.bia-spa-carousel-container')?.querySelector('.bia-spa-carousel-container-header')?.textContent?.trim();
            } else if (this._elementRef.nativeElement.closest('.master-product-carousel')) {
                carouselTitle = this._elementRef.nativeElement.closest('.master-product-carousel').querySelector('[data-carousel-title]')?.getAttribute('data-carousel-title');
            } else if (window['AB'].DATALAYER.isDFTAPage()) {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.previousElementSibling?.textContent?.trim() || '';
            } else {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('lazy-wrapper')?.getAttribute('data-carousel-title') ||
                    this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('.carousel-header-text')?.textContent?.trim() || this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('targeted-wrapper')?.getAttribute('data-carousel-title');
            }

            const productInfoObj: any = {
                id: this.product.id || this.product.itemId,
                adobeMetricA: this.product['adobeMetrics']?.metricA,
                adobeMetricC: this.product['adobeMetrics']?.metricC,
                fullName: this.product.fullName,
                name: this.product.name,
                units: this._commonService.checkPendingOrder() ? this.product.quantity : this.product.qty,
                unitType: this.product.unitQuantity,
                lbs: '0',
                each: '0',
                pricePerUnit: this.product.pricePer,
                listPrice: this.product.price ? this.product.price.toString() : '',
                carouselSection: carouselTitle,
                basePrice: this.product.basePrice ? this.product.basePrice.toString() : '',
                pricingType: this.product.promoType,
                couponFlag: '0',
                couponClipped: '0',
                couponID: '',
                aisleId: this.product.aisleId,
                upc: this.product.upc,
                isCrossSell: isCrossSell,
                isMTO: this.product.isMtoProduct,
                departmentName: this.product.departmentName,
                pathwaysWidget: this.stpprDataObj?.pathwaysWidget,
                sellerId: sellerId ? sellerId : this.product.sellerId,
                sellerName: this.product['sellerName'],
                editOrderFlow: this._commonService.checkPendingOrder() ? true : false,
                snapEligible: this.product.snapEligible,
                isProductTrackingDisabled: this.product.isProductTrackingDisabled ? true : false,
                isP13nGrid: this._elementRef.nativeElement.closest('#p13nProductGrid') ? true : false,
                quantity: this.product.quantity,
                previousPrice: this.analyticsPreviousPrice,
                isPriceDecreased: this.analyticsIsPriceDecreased,
                badges: this.product.badges,
                isPreOrderItem: this.isPreorderElligible(),
                isOrderAmendsFlow: this.orderAmendsOTA,
                containsAlcohol: this.product.containsAlcohol,
                featured: this.product.featured,
                isCustomCake: this.product.isCustomCake,
            };

            if (this.product.unitQuantity == 'LB') {
                productInfoObj.lbs = this.selectedWeight;
            } else if (this.product.unitQuantity == 'EACH') {
                productInfoObj.each = this.product.quantity ? this.product.quantity.toString() : this.product.qty?.toString();
            }

            //TODO: Analytics team should make changes here to not consume coupons from local storage
            const coupons = [];
            // If there are coupons present on the product, filters the information and adds it to the productInfo object
            if (coupons.length > 0) {
                const couponsClipped = coupons.filter(x => x.status === 'C').length;
                const couponsCount = coupons.length;
                const couponIds = coupons.filter(x => x.status === 'C').map(x => x.offerId).toString();

                productInfoObj.couponFlag = couponsCount.toString();
                productInfoObj.couponClipped = couponsClipped.toString();
                productInfoObj.couponID = couponIds;
            }

            // For items that are not on the minicart, set the recommendation type to be used in analytics code
            let isBuyItAgain;
            let isBrPathway;
            let isPicksForYou = false;
            let isP13nGeneric = false;
            if (carouselTitle) {
                const brPathwayCarousel = this.parentCarousel.find('[data-carousel-driven=pathway-search]').length;
                const p13nGenericCarousel = this.parentCarousel.find('[data-carousel-driven=p13n-generic]').length;
                productInfoObj.isBIACarousalProduct = this.parentCarousel.find('[data-carousel-behaviour=bia-spaCarousel]').length ? true : false;
                isBuyItAgain = this.buyItAgainCarousel ? true : false;
                isBrPathway = brPathwayCarousel ? true : false;
                isPicksForYou = carouselTitle.search(/picks for you|picked for you|picks-for-you|picked-for-you/i) !== -1;
                isP13nGeneric = p13nGenericCarousel ? true : false;
                // set placement value for carousel items
                productInfoObj.placement = window['AB'].DATALAYER.setPlacementInfoCarouselItems(this._elementRef.nativeElement);
            }
            const recommendationObj = {
                isCrossSell: isCrossSell,
                isRecommended: this.stpprDataObj?.isRecommended || isPicksForYou || isP13nGeneric,
                isSponsored: this.product['featured'],
                isPastPurchased: isBuyItAgain || this.product['pastPurchased'],
                isBrPathway: isBrPathway
            };
            if (this.product['adId'] || this.product.eventTracking) {
                recommendationObj.isSponsored = true;
            }
            window['AB'].DATALAYER.recommendationInfo(recommendationObj);
            window['AB'].DATALAYER.productInfo(productInfoObj);

            /**
             * update pageFilter with:
             * carousel title (when a user performs any action related to a carousel)
             */
            if (carouselTitle) {
                window['AB'].DATALAYER.isRecipesPage()
                    ? window['AB'].DATALAYER.setCarouselName(`recipes|${carouselTitle}`)
                    : window['AB'].DATALAYER.setCarouselName(`shop|${carouselTitle}`);
            } else {
                window['AB'].DATALAYER.setCarouselName('');
            }

            /**
             * for products that are not in a carousel
             * set metaInfo(number of images clicked on pdp before the user performs a product action)
             */
            if (window['AB'].DATALAYER.isPdp()) {
                if (carouselTitle) {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(false);
                } else {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(true);
                }
            }
        }
    }

    private setAnalyticsSNSProdAction(action: string) {
        if (this.configObj?.programType === '1P_SNS') {
            localStorage.setItem('analyticsSNSProdAction', action);
        }
    }

    private setAnalyticsProductAction() {
        if (window['AB']?.DATALAYER) {
            const analyticsProductID = this.product.id || this.product.itemId;
            if (!window['AB'].DATALAYER.isProductInAnalyticsCart(analyticsProductID)) {
                this.addItemToCartAnalytics = true;
            } else {
                const action = window['AB'].DATALAYER.weightSelectionActionType(analyticsProductID, this.selectedWeight);
                switch (action) {
                    case 'increase':
                        this.increaseQuantityAnalytics = true;
                        break;
                    case 'decrease':
                        this.decreaseQuantityAnalytics = true;
                        break;
                    default:
                        break;
                }
            }
        }
    }

    // function to extract all upcids of non out of stock item from customization data
    private extractUpcids(customizationData: any): string[] {
        const upcIds: string[] = [];
        if (!customizationData?.items) return upcIds;
        const customizations = this.customizationData?.items?.[0]?.customizations || [];

        customizations?.forEach((customization: any) => {
            customization?.options?.forEach((option: any) => {
                if (
                    option?.upcId &&
                    option?.channelInventory?.[this.reservedTimeIntent] === '1'
                ) {
                    upcIds.push(option.upcId);
                }
            });
        });

        return upcIds;
    }

    private extractUpcidQty(customizationData: any): Array<{ upcId: string, qty?: number }> {
        const result: Array<{ upcId: string, qty?: number }> = [];
        if (!customizationData?.items) return result;
        const customizations = customizationData?.items?.[0]?.customizations || [];

        customizations.forEach((customization: any) => {
            (customization?.options || []).forEach((option: any) => {
                const upcId = option?.upcId;
                let qty = option.quantity || 0;
                if (typeof qty === 'string') {
                    qty = Number(qty);
                }
                if (upcId && option?.channelInventory?.[this.reservedTimeIntent] === '1') {
                    if (qty > 0) {
                        result.push({ upcId, qty });
                    } else {
                        result.push({ upcId });
                    }
                }
            });
        });

        return result;
    }

    /**
     * Makes a cart API call to add or update the quantity of a product.
     *
     * @param {number} quantity - The quantity of the product.
     * @returns {void}
     */
    private _cartAPICall(quantity) {
        const oldCartIdLs = JSON.parse(localStorage.getItem('cartId'));
       this.cartV2Service.addOrUpdateProductQuantity(this.product, this.product.id, this.isLBProduct ? quantity.toString() : quantity, false, this.product.sellerId, this.isLBProduct, undefined, this.configObj, this.isGuestAddToCart, this.qtyStepperOptions ?? (
            this.customizationData?.items?.length > 0 && (
                this.isCateringEnabled ? {
                    options: this.extractUpcidQty(this.customizationData),
                    isValid: true,
                    comments: this.customizationData?.items?.[0]?.preferences || ""
                } : {
                    modifierOptionUPCs: {
                        isValid: true,
                        upcs: this.extractUpcids(this.customizationData)
                    }
                }
            )), this.entryId, this.configObj?.dnfFlagOverride?.enableSelectiveCartDfta)
            .subscribe((response) => {
                if (response) {
                    if(response.errorCode) {
                        this.orderAmendsOTAQtyOnRequestFailure = this.product.quantity;
                        this.product.quantity = this.previousQuantity;
                        this.selectedWeight = this.previousQuantity;
                        this.updateState.show = false;
                        this.loadingSpinner = false;
                        this.isQuantityIncreased = false;
                        if(this.orderAmendsOTA) this.showOrderAmendsToaster('error',null,response);
                    } else {
                        const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                        // closing the prev customization modal after the cart API call success
                        if(this.customizationData?.items?.length > 0){
                            this.handleCloseCartSlotModalData();
                        }
                        if(this.isQuantityIncreased) {
                            this.showPriceChangeToast(this.isQuantityIncreased, response);
                            this.isQuantityIncreased = false;
                        }
                        if(this.configObj?.programType === '1P_SNS') {
                            this.callSNSSuccessDispatch();
                        } else if (!this.orderAmendsOTA && this.configObj?.programType !== '1P_SNS') {
                            this.cartService.refreshCart(response, cartName);
                        }

                        if(this.orderAmendsOTA) {
                            this.setFocusOnQuantityInfoButton();
                            this.loadingSpinner = false;
                            this.updateState.show = false;
                            this.previousQuantity = this.product.quantity;
                        }
                        
                        let singleCartresponse: ICart = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                        if (singleCartresponse && (singleCartresponse['cartId'] || singleCartresponse['guestCartId'])) {
                            if (singleCartresponse['cartItems']) {
                                this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'addToCart');

                                // make ad relevance call for all products on search page only
                                if (this.enableAdRelevanceTracking && !this.isCarouselRedesign) {
                                    this._commonService.recordRelevanceImpression(this.product, 'quantityStepper', 'addToCart');
                                }

                                singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                                this.loadingSpinner = false;
                                this.updateState.show = false;

                                if (this.isLBProduct) {
                                    this.focusQtyDropdownBtn();
                                } else {
                                    this.handleReturnFocusForQtyStppr();
                                }

                                if (window['AB']['DATALAYER']) {
                                    const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                                    this._updateAnalyticsProductInfo(sellerId);
                                    window['AB']['DATALAYER'].updateCartType('');
                                    window['AB']['DATALAYER'].updateCart(response, this.product, response['isWYSIWYGEnabled']);

                                    if (this.addItemToCartAnalytics) {
                                        window['AB']['DATALAYER'].addItemToCart();
                                        this.addItemToCartAnalytics = false;
                                    } else if (this.increaseQuantityAnalytics) {
                                        window['AB']['DATALAYER'].increaseItemQuantity();
                                        this.increaseQuantityAnalytics = false;
                                    } else if (this.decreaseQuantityAnalytics) {
                                        window['AB']['DATALAYER'].decreaseItemQuantity();
                                        this.decreaseQuantityAnalytics = false;
                                    }

                                }

                                if(this.calledBy === 'customize-drawer' || this.calledBy === 'prebook-slot-drawer') {
                                    this._commonService.resetCustomizationData();
                                }

                                if (this.showCartSlotModal) {
                                    this.handleClosePrebookModal(this.cartSlotModalData.modalId, this.cartSlotModalData.type, false)
                                }

                                if (this.isPrebookRedirect) {
                                    this.redirectToPrebookPage();
                                }

                                if (this.product.sellerId && this.configObj?.programType !== 'mkp-carousel') {
                                    this.showMkpAddToCartModal(this.product.sellerId, this.product.sellerName, this.product.price, oldCartIdLs);
                                } else if (this.configObj?.programType === 'wineshop') {
                                    this.showStaticFirstTimeCartModal('1P_WINE', oldCartIdLs);
                                }
                            }
                        }

                        if(this.calledBy === 'customize-drawer') {
                            if(!this.qtyStepperOptions?.isCustomizationEditFlow) {
                                window['rightdrawerCompAlRef']?.['component'].closeDrawer();
                            } else {
                                if(this.qtyStepperOptions?.customizationEditSource === 'MINI-CART') {
                                    window['rightdrawerCompAlRef']?.['component'].closeDrawer();
                                    setTimeout(() => {
                                        const url = new URL(window.location.href);
                                        ['src', 'entryId', 'pgm', 'action'].forEach(param => url.searchParams.delete(param));
                                        window.history.replaceState(null, '', url.toString());
                                        if (window['rightdrawerCompAlRef']?.['component']) {
                                            window['rightdrawerCompAlRef']['component'].customizationDetails = {
                                                flowType: 'default',
                                                src: '',
                                                entryId: null
                                            };
                                        }
                                        window['rightDrawerComp']?.openRightFlyout('mini-cart');
                                    }, 400);
                                } else {
                                    window.location.href = '/erums/cart';
                                }
                            }
                        }
                    }
                }
                
               if(!this.orderAmendsOTA) {
                    this.handleCloseCartSlotModalData({ type: 'success' }); // Closes the open modals and resets modal data
                } 
            }, err => {
                console.error('Error while calling Cart API: ' + err.message);
                this.orderAmendsOTAQtyOnRequestFailure = this.product.quantity;
                this.product.quantity = this.previousQuantity;
                this.selectedWeight = this.previousQuantity;
                this.updateState.show = false;
                this.loadingSpinner = false;
                this.isQuantityIncreased = false;
                if(this.orderAmendsOTA) {
                   this.showOrderAmendsToaster('error',null, err);
                } else {
                    if (this.isLBProduct) {
                        this.ctaLabel = this.selectedWeight != 0 ? `${this.selectedWeight?.toFixed(2)} lb` : 'Select wt';
                        this.focusQtyDropdownBtn();
                    } else {
                        this.handleReturnFocusForQtyStppr();
                    }
                }
            });
    }

    /**
     * Show sign in modal to unregistered users.
     */
    private _showSignInModal(configObj?: IConfigObj): void {
        const redirectPath = encodeURIComponent(window.location.href);
        window['SWY'].CONFIGSERVICE.setCookie('ECommRedirectURL', redirectPath, 0);
        if(configObj && configObj?.appName==='weeklyAd') {
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
            const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('sign-in-to-add', navPath) || '';
            window.location.assign(navPath + `${analyticsIcmpid}`);
        } else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }

    /**
     * Removes the product from the cart and performs necessary actions.
     * @private
     */
    private _removeProduct() {
        this.cartV2Service.removeProduct(
            this.product,
            this.product.id,
            this.product.sellerId, this.configObj,
            this.isGuestAddToCart, this.entryId, this.configObj?.dnfFlagOverride?.enableSelectiveCartDfta
        ).subscribe((response: any) => {
            const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
            if(response) {
                if (this.configObj?.programType === '1P_SNS') {
                    this.callSNSSuccessDispatch();
                } else {
                    this.cartService.refreshCart(response, cartName);
                }
                let singleCartresponse :ICart=  this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'removeProduct');
                singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                this.loadingSpinner = false;

                if (window['AB']['DATALAYER']) {
                    const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' || cartName === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                    this._updateAnalyticsProductInfo(sellerId);
                    window['AB']['DATALAYER'].updateCartType('');
                    window['AB']['DATALAYER'].updateCart(response, null, response['isWYSIWYGEnabled']);
                    if (this.removeItemFromCartAnalytics) {
                        window['AB']['DATALAYER'].removeItemFromCart();
                        this.removeItemFromCartAnalytics = false;
                    }
                }
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.product.quantity = this.previousQuantity;
            this.selectedWeight = this.previousQuantity;
            this.loadingSpinner = false;
            this.displayBubble = false;
            if (this.isLBProduct) {
                this.ctaLabel = `${this.selectedWeight?.toFixed(2)} lb`;
                this.focusQtyDropdownBtn();
            } else {
                this.timeouts.push(setTimeout(() => {
                    this.decreaseBtn?.nativeElement.focus();
                }, 100));
            }
        });
    }

    /**
     * Hides the bubble variation and shows the quantity stepper.
     * Sets the focus on the decrement button of the quantity stepper.
     */
    public showQtyStepper() {
        this.displayBubble = false;
        this.updateState.show = false;
        this.timeouts.push(setTimeout(() => {
            this.qtyInfoBtn?.nativeElement.focus();
        }, 100));
    }

    /**
     * Updates the loading message for the quantity stepper.
     * @param qty The quantity value.
     */
    public updateLoadingMessage(qty) {
        // based on previous quantity stepperannouncenment update or else always empty
        if (qty && qty !== this.previousQuantity) {
            this.stepperAnnouncement = `quantity content ${qty} loading`;
            //Reset the announcement to prevent repeated reading
            setTimeout(() => {
                this.stepperAnnouncement = '';
            }, 3000);
        }
    }


    /**
     * Handles the refresh action when an error occurs.
     * It simulates an API call and checks for errors.
     * If the error persists after 3 attempts, it redirects to the product details page.
     */
    public handleRefresh(){
        this.cartSlotModalData = {...this.cartSlotModalData, isLoading: true};
        this.fetchAndHandleCustomizations(
            () => {
              this.showCartSlotModal = true;
              this.cartSlotModalData = this.cartModalConfig['product_customization_modal'];
              this.refreshCount = 0;
            },
            () => {
              this.handleCloseCartSlotModalData();
              this.redirectToProductDetailsPage();
            },
            () => {
              this.cartSlotModalData = { ...this.cartSlotModalData, isLoading: false };
              this.refreshCount++;
              if (this.refreshCount === 3) {
                this.handleCloseCartSlotModalData();
                this.refreshCount = 0;
                this.redirectToProductDetailsPage();
              }
            }
          );
    }

    /**
     * Handles the click event for the start customization button.
     */

    public startCustmization(){
        this.handleCloseCartSlotModalData();
        this.redirectToProductDetailsPage();
    }

    public handleModifyPreviousCustomization(){
        this.handleCloseCartSlotModalData();
        this.redirectToProductDetailsPage({ src: 'bia', pgm: '1p_deli', action: 'edit' });
    }
    /**
     * Redirects to the product details page.
     */

    private redirectToProductDetailsPage(queryParams?: { [key: string]: string }) {
        let productDetailPath = this.product?.name && this._commonService.isSeoEnabled() ?
            this._commonService.buildSeoPdpUrl(this.product.fullName || this.product.name, this.product.id) :
            this._commonService.getProductDetailPath();
        if (productDetailPath) {
            productDetailPath = productDetailPath.replace('(bpn)', this.product.id);
            // Append query parameters to the URL if provided
            if (queryParams) {
                const queryString = new URLSearchParams(queryParams).toString();
                if (queryString) {
                    productDetailPath += `?${queryString}`;
                }
            }
        }
        window.location.href = productDetailPath;
    }

    /**
     * Handle the Add any way Action.
     */

    public handleAddAnywayAction(modelType:string): void {
        this.handlePrebookAction('choose-time-later', 'dd-prebook-modal', modelType, false);
    }

    /**
     * Handle the Add and Update Item Action.
     */
    
    public handleAddItemAndUpdateSlot(modelType:string): void {
        this.handlePrebookAction('reserve-new-time', 'dd-prebook-modal', modelType, true);
    }

    /**
     * Handle prebook actions in a reusable way.
     * 
     * @param action - The slot action to perform (e.g. 'reserve-new-time')
     * @param modalId - The modal ID to target
     * @param shouldRedirect - Whether to redirect to prebook page
     */

    public handlePrebookAction(action: string, modalId: string, modalType: string = '', shouldRedirect?: boolean): void {
        this.handleSlotAction(action, modalId, modalType, shouldRedirect);
    }

    
    /**
     * Validates the session before Performing any cart action.
     * @param action - The type of cart action ('increase', 'decrease', 'update').
     * @param event - The event object associated with the action..
     */
    public beforeCartAction(action: 'increase' | 'decrease' | 'update' | 'weighted'| 'customize'| 'preorder', event: any, selectedWeightIndex?: number) {
        // Editing a future order supports adding new items only inside the T-13 day window.
        // Block the Add/Customize/Preorder path while disabled (defense-in-depth for the CTA).
        const isAddType = action === 'customize' || action === 'preorder' || (action === 'increase' && !this.product?.quantity);
        if (this.isFutureOrderAddDisabled && isAddType) {
            return;
        }
        const isDigitalDeliEnabled = !this._aemService.getFeatureFlagByNameDisable('isDigitalDeliDisabled');
        if (this.isAuthorized || (this.isGuestAddToCart && !(isDigitalDeliEnabled && this.product.isMtoProduct && this.isEcomEnabled))){
            // README: wrapping the entire code as anonymous function to pass it as a callback Function
            const preference = this._userInfoService.getPreference()
                ? this._userInfoService.getPreference().toUpperCase()
                : undefined;
            
            const performCartActionIfSessionValid = () => {
                if (['delivery', 'dug'].includes(preference?.toLowerCase())) {
                    if(action === 'preorder') {
                        if ((this.isPreorderElligible() && (this.product.quantity === undefined || this.product.quantity < 1) && !this.product?.isCustomizable) || (this.isPreorderElligible() && this.calledBy === 'customize-drawer')) {
                            this.openPreorderModal();
                        } else if(this.product?.isCustomizable && this.isPreorderElligible()) {
                            this.redirectToProductDetailsPage();
                        }
                    }
                    else if(action === 'increase') {
                        const isDigitalDeliElgible = this.isDigitalDeliElgible();
                        console.warn('Product Quantity', this.product.quantity);
                        console.warn('Product Qty', this.product.qty);
                        if (!isDigitalDeliElgible  && this.product.isMtoProduct) {
                             if (this.prepTimeExceedsPrebook()  && !this._commonService.byPassReserveSlotCheck(this.product)) {
                                    this.showCartSlotModal = true;
                                    this.cartSlotModalData = this.cartModalConfig['mto'];
                            } else {
                                this.performCartAction(action, event);
                            }
                        } else if(isDigitalDeliElgible && (this.buyItAgainCarousel || ["buyItAgain","buy-it-again"].includes(this.calledBy))) {
                            this.fetchAndHandleCustomizations(
                                () => {
                                  this.showCartSlotModal = true;
                                  this.cartSlotModalData = this.cartModalConfig['product_customization_modal'];
                                },
                                () => {
                                  this.redirectToProductDetailsPage();
                                },
                                () => {
                                  this.showCartSlotModal = true;
                                  this.cartSlotModalData = this.cartModalConfig['previous_customizations_error'];
                                }
                              );
                        } else if (isDigitalDeliElgible && this.calledBy === 'customize-drawer') {
                            if((this.qtyStepperOptions.options.length > 0 && this.qtyStepperOptions.isValid) || (this.qtyStepperOptions.modifierOptionUPCs.upcs.length > 0 && this.qtyStepperOptions.modifierOptionUPCs.isValid)){
                                this.checkAndInitializePrebookSlotDrawer(action, event);
                            } else {
                                this.debounceQtyStepperInfo();
                            }
                        } else {
                            this.performCartAction(action, event);
                        }
                    } else if(action === 'decrease') {
                        this.performCartAction(action, event);
                    } else if(action === 'weighted') {
                        this.performCartAction(action, event, selectedWeightIndex);
                    } else if(action === 'update') {
                        this.performCartAction(action, event);
                    }else if(action === 'customize') {
                        if (window['AB'] && window['AB']['DATALAYER'] && this._commonService.isSearchPage()) {
                            window['AB']['DATALAYER'].analyticsCTATracking(`cta:${window['AB']['DATALAYER'].pathSections.join(':')}|button|customize-cake`);
                            const analyticsProductInfo = {
                                isPastPurchased: this.product?.pastPurchased,
                                isSponsored: this.product?.featured,
                            };
                            window['AB'].DATALAYER.setPfmDetailProductItemToPDP(this._elementRef.nativeElement, this.product, analyticsProductInfo);
                        }
                        this.redirectToProductDetailsPage()
                    }
                } else if (preference === 'J4U') {
                    // Handling weeklyad use case will be handled in a different PR
                    if (window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].analyticsCTATracking(`cta:${window['AB']['DATALAYER'].pathSections.join(':')}|link|add-to-cart`);
                    }
                    window['storeFulfillmentModal'].component.setModalDisplayData(2);
                }
            };

            // README: calling validateSession with a callback function (i.e performCartActionIfSessionValid) which does check for
            // a valid session and perform the cart action
            if(this.isGuestAddToCart){
                performCartActionIfSessionValid();
            } else {
                this._commonService.validateSession(performCartActionIfSessionValid);
            }
        } else {
            if(action === 'increase') {
                if (window['eddlLoadComplete']) {
                    window['AB']['DATALAYER'].setATCFlag(true);
                }
            }
            this._showSignInModal(this.configObj);
        }
    }

    /**
     * Opens preorder modal based on the slot selection
     */
    private openPreorderModal(): void {
        const itemEffectiveStartDate: string = this.product.itemEffectiveStartDate;
        const isPrebookEligble: boolean = this._commonService.preparationTimeExceedsPrebook(this.product, 'abSlot');
        const ctaRefId = 'preOrderButton';
        if (isPrebookEligble) {
            const preference: string = this._userInfoService.getPreference()?.toLowerCase() === 'dug' ? 'pickup' : 'delivery';
            this.cartSlotModalData = {
                ...this.cartModalConfig['preorder_slot'],
                itemEffectiveStartDate,
                preference,
                ctaRefId
            };
        } else {
            if(this.isPreOrderModalEnabled){
                this.cartSlotModalData = {
                    ...this.cartModalConfig['preorder'],
                    itemEffectiveStartDate,
                    ctaRefId
                };
            }else{
                this.handlePreorderItem();
            }
            
        }
        this.showCartSlotModal = true;
    }

    /**
     * Checks if e preparation time exceeds the prebook time
     * @returns true if the preparation time exceeds the prebook time, false otherwise.
     */
    private prepTimeExceedsPrebook(): boolean {
        return localStorage.getItem('abSlot') && this._commonService.preparationTimeExceedsPrebook(this.product, 'abSlot');
    }

    /**
     * Checks if the current slot is valid and the current time is within the allowed range.
     * @returns true if the slot is valid and current time is within the allowed range, false otherwise.
     */
    private isSelectedSlotNotWithInDeliHours(): boolean {
        return !this._productUtilService.isSlotValidAtCurrentTime(window['AB']?.['storeFlagsData']?.['flags']?.['departmentsDetail'], 'Deli','abSlot');
    }

    /**
     * CHecks if the preparation time exceeds the prebook time and initializes the prebook slot drawer.
      * @param action - The action to perform ('increase', 'decrease', 'update').
     * @param event - The event object associated with the action.
     */
    private checkAndInitializePrebookSlotDrawer(action: 'increase' | 'decrease' | 'update' | 'weighted', event:any): void {
        if (this.prepTimeExceedsPrebook() || this.isSelectedSlotNotWithInDeliHours()) {
            window['rightDrawerComp'].closeDrawer();
            const objDrawerData: any = {
                type: 'prebook-slot',
                product: this.product,
                qtyStepperOptions: this.qtyStepperOptions,
                triggeredElement: 'customize-drawer',
                configObj: this.configObj,
            }
            setTimeout (() => {
                this._commonService.rightDrawerSource.next(objDrawerData);
            }, 400);
        } else {
            this.performCartAction(action, event);
        }
    }

      
    /**
     * Performs a cart action based on the specified action and event.
     * @param action - The action to perform ('increase', 'decrease', 'update').
     * @param event - The event object associated with the action.
     */
    private performCartAction(action: 'increase' | 'decrease' | 'update' | 'weighted', event: any, selectedWeightIndex?:number) {
        if (this.calledBy === 'buyItAgainQsc') {
            this.handleQscCartAction(action, event, selectedWeightIndex);
        } else if (this.calledBy === 'customize-drawer') {
            if((this.qtyStepperOptions.options.length > 0 && !this.qtyStepperOptions.isValid) || (this.qtyStepperOptions.modifierOptionUPCs.upcs.length > 0 && !this.qtyStepperOptions.modifierOptionUPCs.isValid)) {
                this.debounceQtyStepperInfo();
            } else {
                this.handleGeneralFlowCartAction(action, event, selectedWeightIndex);
            }
        }else {
                this.handleGeneralFlowCartAction(action, event, selectedWeightIndex);
        }
    }
    /**
     * Fetches and handles customizations for the product.
     * @param onSuccessWithCustomizations - Callback function to execute if customizations are found.
     * @param onSuccessWithoutCustomizations - Callback function to execute if no customizations are found.
     * @param onErrorHandler - Optional callback function to execute in case of an error.
     */

    public fetchAndHandleCustomizations(
        onSuccessWithCustomizations: () => void,
        onSuccessWithoutCustomizations: () => void,
        onErrorHandler?: () => void
      ): void {
        const productId = this.product?.id;
        const shopStoreId = this._userInfoService.getShopStoreId();
      
        if (productId && shopStoreId) {
          this.cartV2Service.getPrefCustomizations(productId, shopStoreId).subscribe({
            next: (response) => {
              this.customizationData = response as CustomizationData;
              const hasCustomizations = response?.items?.[0]?.customizations?.length > 0;
      
              if (hasCustomizations) {
                onSuccessWithCustomizations();
              } else {
                onSuccessWithoutCustomizations();
              }
            },
            error: (err) => {
              if (err && onErrorHandler) {
                onErrorHandler();
              }
            },
          });
        }
      }

    /**
     * Checks if the product is eligible for preorder.
     * @returns true if the product is eligible for preorder, false otherwise.
     */
    private isPreorderElligible(): boolean {
        const { isPreOrderItem } = this.product || {};
        return isPreOrderItem && (!this.configObj?.programType || ['abs', '1P_B2B'].includes(this.configObj?.programType));
    }
      
    /**
     * Checks if the product is eligible for digital deli.
     * This function checks if the product is a customizable MTO product, if the digital deli feature flag is enabled,
     * and if the e-commerce is enabled for the deli department.
     * It returns true if all conditions are met, indicating that the product is eligible for digital
     * @returns true if the product is eligible for digital deli, false otherwise.
     */
    private isDigitalDeliElgible() {
        const isDigitalDeliDisabledFlag = !this._aemService.getFeatureFlagByNameDisable('isDigitalDeliDisabled');
        const { isMtoProduct = false, isCustomizable = false} = this.product || {};
        return isDigitalDeliDisabledFlag && this.isEcomEnabled && isMtoProduct && isCustomizable;
    }

    private handleGeneralFlowCartAction(action: string, event: any, selectedWeightIndex?: number) {
        if(action === 'increase') {
            this.isQuantityIncreased = true;
            if(this.calledBy === 'qtyStepperExpand') {
                if (this.isLBProduct) {
                    this.updateWeightedProductQuantity(action);
                } else {
                    this.product.quantity = this.product.quantity ? this.product.quantity + 1 : 1;
                }
            } else {
                this.product.quantity = this.qtyStepperOptions?.quantity ?? (this.product.quantity ? this.product.quantity + 1 : 1);
            }

            this.displayBubble = false;

            if ((this.product.quantity === 1 || this.calledBy === 'customize-drawer')) {
                this.addFocusToSpinnerBlock();
                this.addItemToCartAnalytics = true;
                this.setAnalyticsSNSProdAction('add-item');
            } else {
                this.refocusButton = event ? event.currentTarget : null;
                this.increaseQuantityAnalytics = true;
                this.setAnalyticsSNSProdAction('quantity-increase');
            }
        }

        if(action === 'decrease' && !this.orderAmendsOTA) {
            if(this.isLBProduct && this.calledBy === 'qtyStepperExpand'){
                this.updateWeightedProductQuantity(action);
            } else {
                this.product.quantity = this.product.quantity - 1;
            }
            if (this.product.quantity === 0) {
                this.refocusButton = null;
                this.timeouts.push(setTimeout(() => {
                    this.addBtn?.nativeElement.focus();
                }, 100));
                if (window['AB']['DATALAYER']) {
                    this.removeItemFromCartAnalytics = true;
                    this.setAnalyticsSNSProdAction('remove-item');
                }
            } else {
                this.refocusButton = event ? event.currentTarget : null;
                this.decreaseQuantityAnalytics = true;
                this.setAnalyticsSNSProdAction('quantity-decrease');
            }
        }

        if(action === 'weighted') {
            this.toggleDisplayWeights(false);
            if(selectedWeightIndex != null && !isNaN(selectedWeightIndex)) {
                if (this.selectedWeight < parseFloat(this.weightList[selectedWeightIndex].weight)) {
                    this.isQuantityIncreased = true;
                }
                this.selectedWeight = parseFloat(this.weightList[selectedWeightIndex].weight);
                this.ctaLabel = `${this.selectedWeight?.toFixed(2)} lb`;
                this.setAnalyticsProductAction();
            } else {
               if(!this.orderAmendsOTA){
                    this.selectedWeight = 0;
                    this.ctaLabel =  'Select wt';
                } 
                this.removeItemFromCartAnalytics = true;
                this.focusQtyDropdownBtn();
            }
            this.product.quantity = this.selectedWeight;
        }

        if(action === 'update') {
            this.updateState.input ??= 0;
            // In order-amends, a decrease is not applied inline (shopper handles it), so keep the quantity unchanged.
            const isOtaDecrease = this.orderAmendsOTA && this.updateState.input < this.product.quantity;
            if (this.updateState.input > this.product.quantity) {
                this.isQuantityIncreased = true;
                this.addFocusToSpinnerBlock();
                this.increaseQuantityAnalytics = true;
                this.setAnalyticsSNSProdAction('quantity-increase');
            } else if (this.updateState.input < this.product.quantity && !isOtaDecrease) {
                if (this.updateState.input === 0) {
                    this.refocusButton = null;
                    this.timeouts.push(setTimeout(() => {
                        this.addBtn?.nativeElement.focus();
                    }, 100));
                    if (window['AB']['DATALAYER']) {
                        this.removeItemFromCartAnalytics = true;
                        this.setAnalyticsSNSProdAction('remove-item');
                    }
                } else {
                    this.addFocusToSpinnerBlock();
                    this.decreaseQuantityAnalytics = true;
                    this.setAnalyticsSNSProdAction('quantity-decrease');

                }
            }
            if (!isOtaDecrease) {
                this.product.quantity = this.updateState.input;
            }
        }

        if (!this.isLBProduct && this.product.maxPurchaseQty && this.product.quantity > this.product.maxPurchaseQty) {
            this.product.quantity = this.product.maxPurchaseQty;
        }
        if (this.isLBProduct && this.product.maxWeight && this.product.quantity > Number(this.product.maxWeight)) {
            this.product.quantity = Number(this.product.maxWeight);
        }

        if(this.calledBy === 'qtyStepperExpand'){
            this.debounceQtyStepperExpand(this.product.quantity);
        }else if(this.orderAmendsOTA){
            this.displayBubble = true;
            this.updateState.show = false;

            this.enableListener();
            if (window['AB']['DATALAYER']) {
                this._updateAnalyticsProductInfo();
                window['AB']['DATALAYER'].updateCartType('');
                const orderAmendsCurrentOrderData = this._commonService.orderAmendsCurrentOrderData;
                const orderAmendsCurrentOrderItems = [...(orderAmendsCurrentOrderData?.orderItems ?? [])]
                const orderItems = !this._commonService.isEmpty(orderAmendsCurrentOrderItems) ? 
                   [...orderAmendsCurrentOrderItems, this.cartV2Service.getOrderItem(this.product, this.product.quantity)].map((orderItem: any) => ({
                        ...orderItem,
                        isFound: true,
                        price: orderItem.itemTotal,
                        id: orderItem.bpnNum,
                        name: orderItem.itemName,
                        totalPrice: orderItem.itemTotal
                    }))
                : [];
                window['AB']['DATALAYER'].updateCart({
                    cartCategory: '1P',
                    isWYSIWYGEnabled: true,
                    selectiveCart: false,
                    orderItems: orderItems
                }, this.product);

                const isExistingOrderItem = orderAmendsCurrentOrderItems.some((item: any) => item.bpnNum === this.product.id && !item.isNewlyAdded);
                if (this.addItemToCartAnalytics || (!isExistingOrderItem && this.increaseQuantityAnalytics)) {
                    window['AB']['DATALAYER'].addItemToCart();
                    this.addItemToCartAnalytics = false;
                    this.increaseQuantityAnalytics = false;
                } else if (this.increaseQuantityAnalytics) {
                    window['AB']['DATALAYER'].increaseItemQuantity();
                    this.increaseQuantityAnalytics = false;
                }
            }
            this.debouncedShowOrderAmendsToaster(action, selectedWeightIndex);
            if (this.isLBProduct) {
                this.quantityAriaLabelMessage = this.selectedWeight + ' lb of ' + this.product.name + ' added to order. Click to update';
            } else {
                const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
                this.quantityAriaLabelMessage = this.product.quantity + ` ${unitTxt} of ` + this.product.name + ' added to order. Click to update';
            }
        } else{
            this.updateLoadingMessage(this.product.quantity);
            this.debounceAddCart(this.product.quantity);
        }
    }


    private focusOnPreviousButton(): string {
        let prevFocusId: string;
        if (this.isLBProduct) {
            prevFocusId = `qtyDropdownBtn_${this.product.id}`;
        } else if (this.product.quantity === 0) {
            prevFocusId = `addToOrderButton_${this.product.id}`;
        } else if (!this.displayBubble) {
            prevFocusId = `qtyInfo_${this.product.id}`;
        } else {
            prevFocusId = `bubble_qtyInfo_${this.product.id}`;
        }
        return prevFocusId;
    }

    private showOrderAmendsToaster(action, selectedWeightedIndex?, response?): void {
        // Close existing toaster if it exists
        if (this.toasterService.toasterRef && this.toasterService.toasterRef.ref && this.toasterService.toasterRef.ref.instance) {
            this.toasterService.toasterRef?.close(false);
            this.toasterService.toasterRef = null;
        }    
        const prevFocusId = this.focusOnPreviousButton();
        // Handle manually entered quantity ('update') as an increase or decrease based on the previous quantity.
        const isWeightedSelection = action === 'weighted' && selectedWeightedIndex != null && !isNaN(selectedWeightedIndex);
        const isUpdateIncrease = action === 'update' && this.updateState.input > this.previousQuantity;
        const isUpdateDecrease = action === 'update' && this.updateState.input < this.previousQuantity;
        const isWeightedRemoval = action === 'weighted' && selectedWeightedIndex == null;
        if(action === 'increase' || isWeightedSelection || isUpdateIncrease) {
            const revertQty = this.previousQuantity;
            this.toasterService.show({
                title: "order-amends-ota",
                message: ToasterMessageHelper.formatRemoveActionMessage(this.product.quantity, this.product.name, this.product.restrictedValue && this.product.restrictedValue > 0),
                type: ToasterType.Success,
                interactiveElement: ToasterMessages.REMOVE_CTA,
                autoCloseTime:5000,
                prevIdToFocus: prevFocusId,
            },{class: 'popup--toaster--right'},(toasterCbAction) => toasterCbAction === ToasterMessages.REMOVE_CTA ? this.handleRemoveActionCTA(revertQty) : this.addCart(this.product.quantity),true);
        } else if(action === 'decrease' || isWeightedRemoval || isUpdateDecrease){
            this.toasterService.show({
                title: "order-amends-ota",
                message: ToasterMessages.GOTOCHAT_MSG,
                type: ToasterType.Info,
                prevIdToFocus: prevFocusId,
                interactiveElement: ToasterMessages.GOTOCHAT_CTA,
            },{class: 'popup--toaster--right'},null,true);
        } else if (action === 'error'){
            const {message, cta} = ToasterMessageHelper.getErrorMessageBasedOnErrorCode(response);
            this.toasterService.show({
                title: "order-amends-ota",
                message: message,
                type: ToasterType.Error,
                interactiveElement: cta,
                prevIdToFocus: prevFocusId,
            },{class: 'popup--toaster--right'},() => this.addCart(this.orderAmendsOTAQtyOnRequestFailure),true);
        }
    }

    private handleRemoveActionCTA(revertToQty: number = this.previousQuantity): void {
        this.toasterService.toasterRef.close();
        this.toasterService.toasterRef = null;
        this.product.quantity = revertToQty;
        this.loadingSpinner = false;
        this.isQuantityIncreased = false;
        const prevFocusId = this.focusOnPreviousButton();
        this.toasterService.show({
            title: "order-amends-ota",
            message: ToasterMessages.REMOVE_ITEM,
            type: ToasterType.Success,
            prevIdToFocus: prevFocusId,
        }, { class: 'popup--toaster--right' }, null, true)
    }

    private  setFocusOnQuantityInfoButton() {
        if (this.isLBProduct) {
            this.quantityAriaLabelMessage = this.selectedWeight + ' lb of ' + this.product.name + ' selected in your quick start cart. Click to update';
        } else {
            const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
            this.quantityAriaLabelMessage = this.product.quantity + ` ${unitTxt} of ` + this.product.name + ' selected in your quick start cart. Click to update';
        }
        setTimeout(() => { this.qtyInfoBtn?.nativeElement.focus() }, 0);
    }
    /**
     * Handles the quantity stepper expand event.
     * @param action - The action to perform ('increase' or 'decrease').
     */
    private updateWeightedProductQuantity(action: string): void {
        const weightIndex = this.product.incrementPriceList.findIndex(
            item => +item.weight === +this.product.quantity
        );
        if (weightIndex === -1 || (action === 'decrease' && weightIndex === 0) || (action === 'increase' && weightIndex === this.product.incrementPriceList.length - 1)) {
            if(action === 'decrease'){
                // Default to the first weight if the current quantity is invalid
                this.product.quantity = parseFloat(this.product.incrementPriceList[0].weight);
                return;
            }
            if(action === 'increase'){
                // Default to the first weight if the current quantity is invalid
                this.product.quantity = parseFloat(this.product.incrementPriceList[this.product.incrementPriceList.length - 1].weight);
                return;
            }
        }
        if (action === 'increase' && weightIndex < this.product.incrementPriceList.length - 1) {
            // If increasing and not at the last weight, move to the next weight
            this.product.quantity = parseFloat(this.product.incrementPriceList[weightIndex + 1].weight);
            return;
        }
        if (action === 'decrease' && weightIndex > 0) {
            // If decreasing and not at the first weight, move to the previous weight
            this.product.quantity = parseFloat(this.product.incrementPriceList[weightIndex - 1].weight);
            return;
        }
    }

    public handleCloseCartSlotModalData(event?: any) {
        this.showCartSlotModal = false;
        this.cartSlotModalData = {};
        if(this.refreshCount){
            this.refreshCount = 0;
        } 
        $('.modal-backdrop')?.remove(); 
        $('body')?.removeClass('modal-open');
        $(`.modal`)?.modal('hide');
        setTimeout(() => {
            // Type 'Success' comes from CART API success to focus on the bubble qty info
            if (event?.type === 'success') {
                $(`#bubble_qtyInfo_${this.product.id}`)?.focus();
            } 
            // ctaRefId comes only in case of closing the modal from the cart slot modal
            if (event?.ctaRefId) {
                $(`#${event.ctaRefId}_${this.product.id}`)?.focus();
            }
        }, 100);
        this.cdr.detectChanges();
    }
    /**
     * Handles the addition of an item from the previous customization.
     * It checks if the product is eligible for digital deli and if the preparation time exceeds prebook.
     * If so, it shows a modal with the available time slots.
     */
    public handleAddItemFromPreviousCustomization(){
        if (this.isDigitalDeliElgible() && (this.prepTimeExceedsPrebook() || this.isSelectedSlotNotWithInDeliHours())) {
            this.handleCloseCartSlotModalData();
            this.updatePrebookData('prebook_modal')
        } else {
            this.handleGeneralFlowCartAction('increase', null);
        }
    }

    /**
     * Adds a preorder item to the cart and closes the modal.
     */
    public handlePreorderItem(): void {
        this.performCartAction('increase', null);
    }

    private handleQscCartAction(action, event, selectedWeightIndex) {
        if (this._quickAddCheckboxService === undefined || this._quickAddCheckboxService === null) {return}
        switch (action) {
            case 'increase':
                this.isQuantityIncreased = true;
                this.product.quantity += 1;
                break;
            case 'decrease':
                if (this.product.quantity == 1) {
                    this._quickAddCheckboxService.setCheckboxState(false);
                    this._quickAddBasketService.updateQuickAddBasketSelectedProperty(this.product.id, false);

                } else if (this.product.quantity > 1) {
                    this.product.quantity -= 1;
                }
                break;
            case 'update':
                this.updateState.input ??= 0;
                if (this.updateState.input >= this.product.quantity) {
                    this.isQuantityIncreased = this.updateState.input != this.product.quantity;
                    this.product.quantity = this.updateState.input;
                    this.updateState.show = false;
                    setTimeout(() => { this.qtyInfoBtn?.nativeElement.focus() }, 0);
                } else if (this.updateState.input < this.product.quantity) {
                    if (this.updateState.input === 0) {
                        this.product.quantity = 1;
                        this._quickAddCheckboxService.setCheckboxState(false);
                        this._quickAddBasketService.updateQuickAddBasketSelectedProperty(this.product.id, false);
                        this.updateState.show = false;
                    } else {
                        this.updateState.show = false;
                        setTimeout(() => { this.qtyInfoBtn?.nativeElement.focus() }, 0);
                    }
                }
                break;

            case 'weighted':
                this.toggleDisplayWeights(false);
                if (selectedWeightIndex != null && !isNaN(selectedWeightIndex)) {
                    if (this.selectedWeight < parseFloat(this.weightList[selectedWeightIndex].weight)) {
                        this.isQuantityIncreased = true;
                    }
                    this.selectedWeight = parseFloat(this.weightList[selectedWeightIndex].weight);
                    this.ctaLabel = `${this.selectedWeight?.toFixed(2)} lb`;
                    this.focusQtyDropdownBtn();
                } else {
                    // Remove case. No need to update quantity, selected weight should remain the same.
                    // Just exit out of view and set selected to false.
                    this._quickAddBasketService.setQuickAddBasketSelectedProperty(this.product.id, false);
                    this._quickAddCheckboxService.setCheckboxState(false);

                }
                this.product.quantity = this.selectedWeight;
                break;
        }

        this.checkMaxPurchaseQty();
        this.updateStepperAnnouncementQsc(this.product.quantity);

        if (this.isLBProduct) {
            this.quantityAriaLabelMessage = this.selectedWeight + ' lb of ' + this.product.name + ' selected in your quick start cart. Click to update';
        } else {
            const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
            this.quantityAriaLabelMessage = this.product.quantity + ` ${unitTxt} of ` + this.product.name + ' selected in your quick start cart. Click to update';
        }

        if (action !== 'weighted') {
            this._quickAddBasketService.setQuickAddBasketItemQuantity(this.product.id, this.product.quantity)
        } else {
            this._quickAddBasketService.setQuickAddBasketItemWeight(this.product.id, this.product.quantity);
        }
    }

    private checkMaxPurchaseQty() {
        if (this.product.maxPurchaseQty && this.product.quantity > this.product.maxPurchaseQty) {
            this.product.quantity = this.product.maxPurchaseQty;
        }
    }

    private updateStepperAnnouncementQsc(qty: number) {
        if (qty && qty !== this.previousQuantity) {
            this.stepperAnnouncement = `Quantity selected changed to ${qty}`;
            this.resetStepperAnnouncement();
        }
    }

    private resetStepperAnnouncement() {
        //Reset the announcement to prevent repeated reading
        setTimeout(() => {
            this.stepperAnnouncement = '';
        }, 3000);
    }

    public showPriceChangeToast(isQuantityIncreased: boolean, cart: any) {
        if (isQuantityIncreased && this._commonService.checkPendingOrder()) {
            const orderedProduct = cart['cartItems']?.find(item => item.itemId === this.product.id);
            const price = this._commonService.getValidProductPrice(this.product);
            const orderedItemPrice = orderedProduct?.price < orderedProduct?.basePrice ? orderedProduct?.price : orderedProduct?.basePrice;
            if (orderedProduct && orderedItemPrice !== price) {
                let msg = `Great news—your price for this item is still $${orderedItemPrice}, based on when you placed your order. `;
                this.analyticsPreviousPrice = orderedItemPrice;
                if (orderedItemPrice > price) {
                    msg = `The price for ${this.product.name} has changed, but your price is still $${orderedItemPrice} based on its price on the day your order was placed. `;
                    this.analyticsIsPriceDecreased = true;
                }
                this.toasterService.show({
                    title: 'OK',
                    message: msg,
                    type: ToasterType.Info,
                    interactiveElement: 'See Policy',
                    interactiveElementLink: 'https://www.albertsonscompanies.com/policies-and-disclosures/terms-of-use/default.aspx',
                }, { class: 'popup--toaster--right'});
            }
        }
    }

    /**
     * Redirect to prebook page
    */
    private redirectToPrebookPage() {
        window.location.href = '/erums/store/prebook';
    }

    public handleSlotAction(type: string, modalId: string, modalType: string = '', shouldRedirect:boolean) {
        const abSlotFromLS = localStorage.getItem('abSlot');
        const abSlot = abSlotFromLS ? JSON.parse(abSlotFromLS) : {};
        const slotId = abSlot?.slotId;
        const slotType = abSlot?.type;

        if (slotId) {
            const delRequest = this._deleteSlotRequest(slotId, slotType);
            // README: Delete current prebooked slot
            this._http.delete(delRequest.url, {
                headers: new HttpHeaders(delRequest.headers), responseType: 'text' as const
            }).subscribe((data) => {
                if (window['AB']['COMMON'].isLSCompatible()) {
                    localStorage.removeItem('abSlot');
                }
                // README: Resets reserve nav message after the slot is deleted
                this._resetReserveNavText();

                this.isPrebookRedirect = type === 'reserve-new-time';
                // README: Add item to cart
                this.performCartAction('increase', null);
            }, (err) => {
                // README: Close modal
                this.handleClosePrebookModal(modalId, modalType, shouldRedirect);
            });
        }
    }

    /**
     * Handles Right Drawer/Modal close event.
     */
    private handleClosePrebookModal(modalId: string, modalType: string, shouldRedirect:boolean = false): void {
        if (modalType === 'prebook_slot_drawer') {
            window['rightDrawerComp'].closeDrawer();
        } else {
            $(`#${modalId}`).modal('hide');
            this.handleCloseCartSlotModalData();
        }
        if (shouldRedirect) {
            this.redirectToPrebookPage();
        }
    }

    /**
     * Handles Right Drawer back button click event.
     */
    public handlePreviousPageAction(): void {
        window['rightDrawerComp'].closeDrawer();
        setTimeout(() => {
            const drawerObj: any = {
                configObj: this.configObj,
                type: 'customize-drawer',
                product: this.product,
                triggeredElement: 'item-unavailable'
            };
            this._commonService.rightDrawerSource.next(drawerObj);
        }, 400);
    }

    /**
     * Constructs the request for prebook delete slot
    */
    private _deleteSlotRequest(slotId : string, slotType:any) {
        const origin = window.location.origin;
        const storeId = window['AB'].userInfo.branchId;
        const userChannel = this._userInfoService.getUserChannel() ? this._userInfoService.getUserChannel().toUpperCase() : '';

        // isReservationServiceEnabled (default false): true -> reservation service endpoint, false -> slot promise service endpoint
        const isReservationServiceEnabled = window['SWY'].CONFIGSERVICE.featureToggleConfig?.isReservationServiceEnabled === true;
        let path = window['SWY'].CONFIGSERVICE.osdpConfig[isReservationServiceEnabled ? 'osdp.reservation.service.endpoint' : 'osdp.slot.promise.service.endpoint'];
        const headers = window['AB'].ecommHttpOptionsOsdp;
        headers.clientId = 'CC';
        headers.storeId = storeId;
        // update path if mockinator is requested
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService) {
            const mode = this._utilService.getParams('mode');
            // check mode coming from request parameter
            if (mode === 'record') {
                // prepend record base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.recorderBaseUrl}${path}`;
            } else if (mode === 'playback') {
                // prepend playback base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.playbackBaseUrl}${path}`;
            }
            // update subscription key with mockinator subscription key if mode is either playback or record
            headers['ocp-apim-subscription-key'] = (mode === 'record' || mode === 'playback') ? wiremockAPIDetails?.subscriptionKey : headers['ocp-apim-subscription-key'];
        }
        if (userChannel && (userChannel === 'DELIVERY' || userChannel === 'PICKUP')) {
            if (userChannel === 'PICKUP') {
                headers['serviceType'] = 'DUG';
            } else {
                headers['serviceType'] = userChannel;
            }
        }

        let slotTypeParameter = '';
        if (slotType === 'FLASH')
            slotTypeParameter = '?type=FLASH';

        return {
            url: `${origin}${path}/reserve/${storeId}/${slotId}${slotTypeParameter}`,
            headers: headers
        };
    }
    /**
     * Resets reserve nav text after the slot has been deleted
     */
    private _resetReserveNavText() {
        // if new navigation flag is enabled, reset the reserve nav text using new classes
        const navEngineEnabled = !this._aemService.getFeatureFlagByNameDisable('isNavigationEngineDisabled');
        if (navEngineEnabled) {
            const reserveNav = document.querySelector('.s_nav_fulfillment_link.fulfillment_link_reserve');
            reserveNav.innerHTML = 'Reserve';
        } else {
            if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'dug') {
                const reserveNav = document.querySelector('.reserve-nav__text_pickup');
                if (reserveNav) {
                    reserveNav.textContent = 'Reserve a pickup time';
                }
            } else if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'delivery') {
                const reserveNav = document.querySelector('.reserve-nav__text_delivery');
                if (reserveNav) {
                    reserveNav.textContent = 'Reserve a delivery time';
                }
            }
        }
    }

    /**
     * Analytics method for tracking link clicks on MTO modal
     *
    */
    public analyticsMTOClicks(linkClicked) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalClickEvents(`mto-pickup|${linkClicked}`);
        }
    }

    /**
     * Handles returning focus to the appropriate element for the quantity stepper.
     */
    private handleReturnFocusForQtyStppr() {
        if(this.refocusButton) {
            this.refocusButton.focus();
        } else {
            this.timeouts.push(setTimeout(() => {
                this.qtyInfoBtn?.nativeElement.focus();
            }, 100));
        }
    };

    /**
     * Toggles the display of weights.
     * If the weights are shown, they are hidden.
     * If the weights are not shown, the weight list is initialized.
     */
    public displayWeights() {
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;

        if(preference === 'J4U') {
            window['storeFulfillmentModal'].component.setModalDisplayData(2);
        } else {
            if(this.showWeights) {
                this.toggleDisplayWeights(false);
            } else {
                if(this.weightList && this.weightList.length > 0) {
                    this.toggleDisplayWeights(true);
                    this.setADANavigation();
                } else {
                    this.initializeWeightList();
                }
            }
        }
    };

    public toggleDisplayWeights(isShown:boolean){
        if(this.isCarouselRedesign){
            if(isShown){
                $(this._elementRef.nativeElement).closest('.product-carousel-v2').addClass('pc-z-index');
            }else{
                $(this._elementRef.nativeElement).closest('.product-carousel-v2').removeClass('pc-z-index');
            }
        }
        this.showWeights = isShown;
    }

    /**
     * Sets up the ADA navigation for the quantity dropdown.
     * This function attaches event listeners to handle keyboard navigation and focus management.
     * It also updates the estimated price based on the selected item.
     */
    private setADANavigation() {
        setTimeout(()=> {
            const firstItem = "#dropdown-itm0";
            const listItem = ".dropdown-item.wt-dropdown__menu__container__item";
            const removeBtn = ".wt-dropdown__menu__container__item-remove";

            $(firstItem).focus();
            this.estimatedPrice = parseFloat(this.weightList[0].price);

            const that = this;
            $(listItem).on('keydown keypress', function (e) {
                if ($('this:focus')) {
                    let nextFocusableElement = null;
                    if(e.which === 40){
                        nextFocusableElement =  $(this).next();
                    } else if (e.which === 38) {
                        nextFocusableElement =  $(this).prev();
                    };

                    if(nextFocusableElement && nextFocusableElement.length && nextFocusableElement.length > 0) {
                        if(!nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove")) {
                            const nextIndex = nextFocusableElement.get(0).id.replace("dropdown-itm","");
                            that.estimatedPrice = parseFloat(that.weightList[Number(nextIndex)].price);
                        } else if (nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove") &&
                            !nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove--disabled")) {
                            that.estimatedPrice = 0;
                        }

                        if(!nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove--disabled")) {
                            nextFocusableElement.focus();
                        }
                    }
                }
            });

            $(removeBtn).on('keydown keypress', function (e) {
                if ($('this:focus')) {
                    if(e.which === 38) {
                        const element =  $(this).prev();
                        element.focus();
                    }
                }
            });
        },500);
    };

    /**
     * Initializes the weight list by making a request to get the increment price list for the product's UPC.
     */
    public initializeWeightList() {
        this.cartV2Service.getIncrementPriceList(this.product.upc)
            .subscribe(response => {
                if(response) {
                    const priceAndPromoResponse = response['priceAndPromoResponse'];
                    if(priceAndPromoResponse && priceAndPromoResponse.length > 0) {
                        this.weightList = priceAndPromoResponse[0]['incrementPriceList'];
                        if(this.weightList && this.weightList.length > 0) {
                            this.toggleDisplayWeights(true);
                            this.setADANavigation();
                        }
                    }
                }
            }, err => {
                this.toggleDisplayWeights(false);
            });
    };

    /**
     * Refocuses the select weight button.
     */
    public focusQtyDropdownBtn() {
        this.timeouts.push(
            setTimeout(()=> {
                $(`#qtyDropdownBtn_${this.product.id}`).focus();
            },100)
        );
    };

    /**
     * Handles the mouse enter event for the quantity stepper.
     * @param i - The index of the item.
     */
    public mouseEnter(i) {
        this.estimatedPrice = parseFloat(this.weightList[i].price);
        this.timeouts.push(
            setTimeout(()=> {
                $('#dropdown-itm'+i).focus();
            },0)
        );
    };

    /**
     * Handles the mouse enter event for the remove button.
     * Resets the estimated price to 0.
     */
    public mouseEnterRemoveBtn() {
        this.estimatedPrice = 0;
    };

    /**
    * Add focus to spinner block
    */
    private addFocusToSpinnerBlock() {
        this.loadingSpinner = true;
        this.refocusButton = null;
        this.timeouts.push(setTimeout(() => {
            this.spinnerBlock?.nativeElement.focus();
        }, 100));
    }

    /**
    * Update Quantity Manually 
    */

    public showUpdateQtyInput() {
        this.updateState.input = this.product.quantity;
        this.updateState.show = true;
        setTimeout(()=> {
            $(`#qtyInfoControl_${this.product.id}`).focus();
        },100)
    }

    public showQscUpdateQtyInput() {
        // When switching from stepper to input state, we lose focus. This resulted in a bug that wouldnt allow
        // user to switch to input state after clicking on the + or - button. 
        // This fixes it. 
        setTimeout(() => {
            $(`#qtyInfoControl_${this.product.id}`).focus();
        }, 0);

        // Clear timer if previously updated quantity to prevent closing while in input view.
        this.showUpdateQtyInput();
    }

    /**
     * This function is called on cart api success when program type is 1P_SNS
    */

    callSNSSuccessDispatch() {
        const payloadData = {
            'data-bpn': this.product.id,
            'qty':  this.product.quantity
        }
        this._commonService.dispatchCustomOneTimeEvent('snsOneTime', 'productQtyUpdateSuccess', payloadData);
    }

    /**
     * Input Keyup event. Used to prevent numbers greater than maxPurchaseQty value.
     * Event will trigger when key is released.
     */
    public inputQtyKeyup(event: any){
        if (this.product.maxPurchaseQty && event.target.value > this.product.maxPurchaseQty) {
            event.preventDefault();
            this.updateState.input = this.product.maxPurchaseQty;
        }
    }

    /**
        * Input Keydown event. Used to remove e,+,- and period from quantity input.
        * Event will trigger when key is pressed.
        */
    public inputQtyKeydown(event: any): any {
        const e = <KeyboardEvent>event;
        const keyCode = !e.which ? e.keyCode : e.which;
        const actionsToAllow = [8, 9, 13, 37, 38, 39, 40, 46];  // backspace, tab, enter, arrows and delete
        const keysToAllow = '0123456789';                       // had to do this because firefox sees 1 as ! and ¡ etc if we use keyCodes

        // Prevent all but numbers, backspace, delete, tab and enter
        if (!(actionsToAllow.includes(keyCode) || keysToAllow.includes(e.key))) {
            e.preventDefault();
        }

        // Prevent double space keystroke adding a decimal/. to input
        if (event.key == ' '){
            const inputField =  (document.querySelector(`#qtyInfoControl_${this.product.id}`) as HTMLInputElement)
            inputField.value = inputField.value.replace(/[^0-9]*/g,'');
        }
    }
    /**
    * This function shows the first time cart modal authored version (static).
    */
    public showStaticFirstTimeCartModal(cartId, cartIdLs) {
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        if (cartIdLs && cartIdLs[cartId]) {
            return;
        } else {
            window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
            if (window['AB'] && window['AB'].DATALAYER) {
                window['AB'].DATALAYER.addedToSellerTypeModalTracking('wineshop');
            }
        }
    }

    /**
    * Triggers MKP Add to cart Modal when user adding seller Product for first time
    * Checks cartId local storage to determine the cart seller cart activity
    * Replaces modal placeholders with order min and product price
    * **/
    public showMkpAddToCartModal(sellerId, sellerName, productPrice, cartIdLs) {
        if (cartIdLs && cartIdLs[sellerId]) {
            return;
        } else {
            this.showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice);
        }
    }

    /**
  * This function shows the first time cart modal api driven version (dynamic).
  */
    private showDynamicFirstTimeCartModal(sellerId , sellerName, productPrice) {
        // generate add to cart modal based on program type
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        const cartModal = $(cartModalId);

        // replace sellerId and sellerName in image url and alt text and set src and alt text
        const mkpLogo = $(cartModalId + ' .error-state-modal__logo img');

        const mkpLogoPlaceholder = mkpLogo.attr('data-image-placeholder');
        const mkpAltPlaceholder = mkpLogo.attr('data-alt-placeholder');
        mkpLogo.attr('src', mkpLogoPlaceholder?.replace('(sellerId)', sellerId));
        mkpLogo.attr('alt', mkpAltPlaceholder?.replace('(sellerName)', sellerName));

        // replace sellerName placeholder in modal title and set inner html
        const modalSellerCartTitle = $(cartModalId + ' .error-state-modal__title');
        const messagePlaceholder = modalSellerCartTitle.attr('data-message-placeholder');
        const modalTitleHtml = messagePlaceholder?.replace('(sellerName)', sellerName);
        // update element html with replaced value
        modalSellerCartTitle?.html(modalTitleHtml);
        cartModal.attr("aria-label",modalTitleHtml);

        // calculate if current product price is > order minimum and replace current price and order minimum placeholder
        const mkpOrderMinModalMessage = $(cartModalId + ' .error-state-modal__shipping-text');
        const noOrderMinElem = $(cartModalId + ' .error-state-modal__noOrderMin');
        const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__cp');
        // add to cart Minimum order price class
        const mkpOrderMinModalMessage_mo = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__mo');
        // get mkpShipping local storage to get the shipping details
        const mkpSellerShippingInfo = JSON.parse(localStorage.getItem('mkpShipping'));
        // check if shipping info is available in local storage else return

        if(mkpSellerShippingInfo && mkpSellerShippingInfo['shippingInfo'][sellerId]) {
            const domesticShippingFreeThreshold = mkpSellerShippingInfo['shippingInfo'][sellerId].domesticShippingFreeThreshold;
            const shippingFee = mkpSellerShippingInfo['shippingInfo'][sellerId].shippingFee;
            const modalShippingText = $(cartModalId + ' .error-state-modal__text');
            const qualifyFreeShipping = $(cartModalId + ' .error-state-modal__qualifyFreeShipping');
            const domesticFreeShipping = $(cartModalId + ' .error-state-modal__domesticFreeShipping');

            /**
             * if domestic free shipping threshold > 0 and shipping fee > 0
             * Show free shipping message if threshold is > product price else fall back to min cart threshold
             * */
            if (domesticShippingFreeThreshold > 0 && shippingFee > 0) {
                const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__domesticFreeShipping .error-state-modal__shipping-text__cp');
                if(domesticShippingFreeThreshold > productPrice) {
                    mkpOrderMinModalMessage_cp.html('$' + ((domesticShippingFreeThreshold - productPrice).toFixed(2)).toString());
                    domesticFreeShipping.removeClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                    modalShippingText.removeClass('d-none')
                    qualifyFreeShipping.addClass('d-none');
                } else {
                    qualifyFreeShipping.removeClass('d-none')
                    domesticFreeShipping.addClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                }
            } else {
                const orderMin = mkpSellerShippingInfo['shippingInfo'][sellerId].minCartThresholdValue;
                if (orderMin && orderMin > 0 && orderMin > productPrice) {
                    // calculate order min from min threshold and round off
                    mkpOrderMinModalMessage_cp.html('$' + ((orderMin - productPrice).toFixed(2)).toString());
                    // update order minimum value with actual value from MKP Shipping LS
                    mkpOrderMinModalMessage_mo.html('$' + orderMin.toString());
                    noOrderMinElem.addClass('d-none');
                    mkpOrderMinModalMessage.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                } else if (orderMin === 0) {
                    // if order minimum is 0 then show no order minimum element
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                } else {
                    // above conditions fails then hide order minum elements
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.addClass('d-none');
                }
            }

            // Shipping fee elements
            const shippingFeeElem = $(cartModalId + ' .error-state-modal__text__shipping');
            const freeShippingElem = $(cartModalId + ' .error-state-modal__freeShipping');

            // if shipping fee > 0 then update html with shipping fee else remove shipping html from DOM
            /**
             * Check if domestic free shipping flag is enabled and
             * if domestic free shipping is > 0 product price is less than threshold then show shipping fee
             * else hide
             * */
            if (shippingFee && shippingFee > 0 && (domesticShippingFreeThreshold > 0 && domesticShippingFreeThreshold > productPrice || domesticShippingFreeThreshold < 1)) {
                shippingFeeElem?.html('$' + shippingFee);
                freeShippingElem.addClass('d-none');
                modalShippingText.removeClass('d-none');
            } else if(shippingFee === 0) {
                modalShippingText.addClass('d-none');
                freeShippingElem.removeClass('d-none');
            }
            else {
                modalShippingText?.addClass('d-none');
                freeShippingElem?.addClass('d-none');
            }
            if($('.main-wrapper').attr('data-custom-page-type') === 'mkp-cross-seller-page'){
                $(".modal-footer__action-btn__cart").html('Go to Seller');
                const goToSeller = $(cartModalId + ' .modal-footer__action-btn__cart');
                goToSeller.attr('seller-url', this._commonService.getSellerLandingPath(sellerId));
            }

            this.updateSrMsgs(cartModalId);

        } else {
            console.warn('mkpShipping local storage missing or current seller shipping info is not available');
        }
        window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.addedToSellerTypeModalTracking('marketplace');
        }
    }

    // To make ADA read the message as a whole instead of span by span
    private updateSrMsgs(cartModalId){
        const minOrderShippingContent = $(cartModalId + ' .error-state-modal__shipping-text-content').text();
        const domesticFreeShippingContent = $(cartModalId + ' .error-state-modal__domesticFreeShipping-content').text();
        const qualifyFreeShippingContent = $(cartModalId + ' .error-state-modal__qualifyFreeShipping-content').text();
        const shippingTextContent = $(cartModalId + ' .error-state-modal__text-content').text();

        $(cartModalId + ' .error-state-modal__shipping-text-sr').text(minOrderShippingContent);
        $(cartModalId + ' .error-state-modal__domesticFreeShipping-sr').text(domesticFreeShippingContent);
        $(cartModalId + ' .error-state-modal__qualifyFreeShipping-sr').text(qualifyFreeShippingContent);
        $(cartModalId + ' .error-state-modal__text-sr').text(shippingTextContent);
    }
}
